<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-subscription-level-dialog-form">
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Report Subscription Type</mat-label>
      <mat-select name="data.reportSubscriptionLevel.reportSubscriptionTypeId"
                  [(ngModel)]="data.reportSubscriptionLevel.reportSubscriptionTypeId">
        <mat-option *ngFor="let reportSubscriptionType of data.reportSubscriptionTypes"
                    [value]="reportSubscriptionType.reportSubscriptionTypeId">{{ reportSubscriptionType.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Subscription Type</mat-label>
      <div>
        <ng-container *ngFor="let reportSubscriptionType of data.reportSubscriptionTypes">
          <ng-container *ngIf="reportSubscriptionType.reportSubscriptionTypeId == data.reportSubscriptionLevel.reportSubscriptionTypeId">
            {{ reportSubscriptionType.name }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field>
      <mat-label>Description</mat-label>
      <input matInput
             name="data.reportSubscriptionLevel.description"
             [(ngModel)]="data.reportSubscriptionLevel.description" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Max Admin Users</mat-label>
      <input matInput
             name="data.reportSubscriptionLevel.maxAdminUsers"
             [(ngModel)]="data.reportSubscriptionLevel.maxAdminUsers" />
    </mat-form-field><br />
    <mat-form-field>
      <mat-label>Max Report Users</mat-label>
      <input matInput
             name="data.reportSubscriptionLevel.maxReportUsers"
             [(ngModel)]="data.reportSubscriptionLevel.maxReportUsers" />
    </mat-form-field>
    <ng-container>
      <mat-checkbox name="data.reportSubscriptionLevel.allowInvoice" [(ngModel)]="data.reportSubscriptionLevel.allowInvoice">Allow Invoice?</mat-checkbox>
    </ng-container><br />
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription Level
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
